import { cargas } from './cargas'

export const all = {
    rpaCargas: cargas
}